import "./logo.scss";

import * as React from "react"

export const Logo = () => (
  <svg
    className="Logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 570.62 123.55"
  >
    <defs>
      <linearGradient
        id="linear-gradient-111"
        x1={63.91}
        x2={61.94}
        y1={68.49}
        y2={-15.71}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} />
        <stop offset={0.04} stopColor="#000606" />
        <stop offset={0.09} stopColor="#001415" />
        <stop offset={0.22} stopColor="#001b1d" />
        <stop offset={0.42} stopColor="#003031" />
        <stop offset={0.67} stopColor="#005153" />
        <stop offset={0.9} stopColor="#00777a" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-111-2"
        x1={90.01}
        x2={91.83}
        y1={17.89}
        y2={139.36}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} />
        <stop offset={0.35} stopColor="#000202" />
        <stop offset={0.49} stopColor="#000909" />
        <stop offset={0.6} stopColor="#001516" />
        <stop offset={0.69} stopColor="#002627" />
        <stop offset={0.77} stopColor="#003d3e" />
        <stop offset={0.84} stopColor="#00585a" />
        <stop offset={0.9} stopColor="#00777a" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-111-3"
        x1={94.5}
        x2={96.32}
        y1={13.3}
        y2={134.77}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} />
        <stop offset={0.42} stopColor="#003f40" />
        <stop offset={0.74} stopColor="#00676a" />
        <stop offset={0.9} stopColor="#00777a" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-111-4"
        x1={35}
        x2={36.82}
        y1={18.71}
        y2={140.18}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} />
        <stop offset={0.33} stopColor="#000202" />
        <stop offset={0.47} stopColor="#00090a" />
        <stop offset={0.59} stopColor="#001616" />
        <stop offset={0.68} stopColor="#002728" />
        <stop offset={0.76} stopColor="#003e40" />
        <stop offset={0.84} stopColor="#005a5c" />
        <stop offset={0.9} stopColor="#00777a" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-111-5"
        x1={29.07}
        x2={30.89}
        y1={15.4}
        y2={136.87}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} />
        <stop offset={0.07} stopColor="#000b0c" />
        <stop offset={0.46} stopColor="#004547" />
        <stop offset={0.75} stopColor="#00696c" />
        <stop offset={0.9} stopColor="#00777a" />
      </linearGradient>
      <style>{".cls-111-1{fill:#00777a}"}</style>
    </defs>
    <title>{"logo_kolor"}</title>
    <g id="Layer_2-111" data-name="Layer 2">
      <g id="Layer_1-2-111" data-name="Layer 1">
        <path
          d="M136.8 101.29V42.83h8.94l36.67 45.1H178v-45.1h10.69v58.46h-8.94l-36.58-45.1h4.43v45.1ZM218 101.88a21 21 0 0 1-8.77-1.72 13.51 13.51 0 0 1-5.81-4.76 12.1 12.1 0 0 1-2-6.89 12.89 12.89 0 0 1 1.79-6.76 12.09 12.09 0 0 1 5.84-4.75 28 28 0 0 1 10.86-1.76h12.94v6.93h-12.19c-3.51 0-5.89.58-7.14 1.72a5.57 5.57 0 0 0-1.88 4.3 5.23 5.23 0 0 0 2.25 4.42 10.33 10.33 0 0 0 6.27 1.68 13.56 13.56 0 0 0 6.89-1.76 10.36 10.36 0 0 0 4.47-5.18l1.67 6.27a11.63 11.63 0 0 1-5.35 6.09 19.82 19.82 0 0 1-9.84 2.17Zm14-.59v-9.1l-.5-1.84V74.56a9.19 9.19 0 0 0-2.8-7.14c-1.87-1.69-4.69-2.54-8.48-2.54a23.27 23.27 0 0 0-7.22 1.17 19.27 19.27 0 0 0-6.19 3.25l-4.09-7.6a26.34 26.34 0 0 1 8.61-4.17 36.71 36.71 0 0 1 10.27-1.42q9.76 0 15 4.67t5.26 14.37v26.14ZM270.19 101.88a38.72 38.72 0 0 1-10.78-1.47 28.64 28.64 0 0 1-8.18-3.55l4-7.93a27.13 27.13 0 0 0 7.18 3.13 30 30 0 0 0 8.43 1.21c3.23 0 5.59-.43 7.06-1.29a4 4 0 0 0 2.22-3.55 3.12 3.12 0 0 0-1.51-2.8 11.6 11.6 0 0 0-3.92-1.46c-1.62-.34-3.41-.64-5.39-.92s-3.95-.65-5.93-1.13A20.69 20.69 0 0 1 258 80a11.18 11.18 0 0 1-3.92-3.72 11.5 11.5 0 0 1-1.51-6.27 11.57 11.57 0 0 1 2.43-7.3 15.72 15.72 0 0 1 6.8-4.89 28 28 0 0 1 10.4-1.75 41.52 41.52 0 0 1 9.06 1A26.81 26.81 0 0 1 289 60l-4.11 8a21 21 0 0 0-6.35-2.55 30.37 30.37 0 0 0-6.43-.71q-4.68 0-7 1.38a4.06 4.06 0 0 0-2.34 3.55 3.35 3.35 0 0 0 1.51 3 11.58 11.58 0 0 0 3.92 1.55c1.62.36 3.41.7 5.39 1s3.94.7 5.89 1.17a23.27 23.27 0 0 1 5.38 2 10.38 10.38 0 0 1 4 3.64 11.12 11.12 0 0 1 1.51 6.09 11.28 11.28 0 0 1-2.47 7.31 15.94 15.94 0 0 1-6.93 4.76 30.07 30.07 0 0 1-10.78 1.69ZM321.38 101.88a27.12 27.12 0 0 1-13-3 21.65 21.65 0 0 1-8.61-8.1A22.74 22.74 0 0 1 296.74 79a23.21 23.21 0 0 1 3-11.82 21.6 21.6 0 0 1 8.19-8.1 23.69 23.69 0 0 1 11.9-3A23.2 23.2 0 0 1 331.41 59a20.89 20.89 0 0 1 8 8.06 24.55 24.55 0 0 1 2.93 12.28v1.46c0 .59-.07 1.1-.13 1.54H305V75.4h31.66l-4.18 2.17a13.13 13.13 0 0 0-1.48-6.72 11.62 11.62 0 0 0-4.47-4.59 13.17 13.17 0 0 0-6.68-1.63 13.71 13.71 0 0 0-6.73 1.63 11.1 11.1 0 0 0-4.55 4.63 14.58 14.58 0 0 0-1.59 6.93v1.67a13.85 13.85 0 0 0 1.8 7.1 12.24 12.24 0 0 0 5.14 4.8 16.65 16.65 0 0 0 7.76 1.72 17.38 17.38 0 0 0 6.77-1.26 15.76 15.76 0 0 0 5.34-3.67l5.68 6.51a20 20 0 0 1-7.64 5.35 27.68 27.68 0 0 1-10.45 1.84ZM367.32 101.88a38.72 38.72 0 0 1-10.78-1.47 28.64 28.64 0 0 1-8.18-3.55l4-7.93a27.28 27.28 0 0 0 7.18 3.13 30.11 30.11 0 0 0 8.46 1.21q4.85 0 7.05-1.29a4 4 0 0 0 2.22-3.55 3.1 3.1 0 0 0-1.51-2.8 11.6 11.6 0 0 0-3.92-1.46c-1.62-.34-3.41-.64-5.39-.92s-3.95-.65-5.93-1.13a20.62 20.62 0 0 1-5.39-2.12 11.12 11.12 0 0 1-3.93-3.72 11.5 11.5 0 0 1-1.5-6.27 11.56 11.56 0 0 1 2.42-7.3 15.69 15.69 0 0 1 6.81-4.89 27.9 27.9 0 0 1 10.39-1.75 41.61 41.61 0 0 1 9.07 1 26.74 26.74 0 0 1 7.72 2.93L382 68a21 21 0 0 0-6.35-2.55 30.3 30.3 0 0 0-6.43-.71q-4.68 0-7 1.38a4.05 4.05 0 0 0-2.33 3.55 3.36 3.36 0 0 0 1.5 3 11.55 11.55 0 0 0 3.93 1.55c1.61.36 3.4.7 5.38 1s3.94.7 5.89 1.17a23.52 23.52 0 0 1 5.39 2 10.42 10.42 0 0 1 4 3.64 11 11 0 0 1 1.51 6.09A11.23 11.23 0 0 1 385 95.4a15.94 15.94 0 0 1-6.93 4.76 30.07 30.07 0 0 1-10.75 1.72ZM392.88 118.08a21.86 21.86 0 0 1-5.47-.67 14.1 14.1 0 0 1-4.47-1.92l3-7.77a10.15 10.15 0 0 0 6.1 1.76 5.61 5.61 0 0 0 4.43-1.8 7.77 7.77 0 0 0 1.58-5.3V56.69h10.44v45.44q0 7.35-4.05 11.65t-11.56 4.3Zm10.35-68.74a6.55 6.55 0 0 1-4.8-1.84 6.05 6.05 0 0 1-1.88-4.5 5.89 5.89 0 0 1 1.88-4.34 6.59 6.59 0 0 1 4.8-1.84 6.9 6.9 0 0 1 4.77 1.71 5.66 5.66 0 0 1 1.87 4.38 6.28 6.28 0 0 1-1.83 4.55 6.46 6.46 0 0 1-4.81 1.88ZM444.24 101.88a27.19 27.19 0 0 1-13-3 21.62 21.62 0 0 1-8.6-8.1 22.74 22.74 0 0 1-3-11.82 23.21 23.21 0 0 1 3-11.82 21.57 21.57 0 0 1 8.18-8.1 23.75 23.75 0 0 1 11.91-3A23.13 23.13 0 0 1 454.26 59a20.85 20.85 0 0 1 8 8.06 24.55 24.55 0 0 1 2.93 12.28v1.46c0 .59-.07 1.1-.12 1.54h-37.2V75.4h31.66l-4.18 2.17a13 13 0 0 0-1.55-6.72 11.53 11.53 0 0 0-4.46-4.59 13.17 13.17 0 0 0-6.68-1.63 13.71 13.71 0 0 0-6.73 1.63 11 11 0 0 0-4.55 4.63 14.58 14.58 0 0 0-1.59 6.93v1.67a13.85 13.85 0 0 0 1.8 7.1 12.24 12.24 0 0 0 5.14 4.8 16.65 16.65 0 0 0 7.76 1.72 17.38 17.38 0 0 0 6.77-1.26 15.85 15.85 0 0 0 5.34-3.67l5.68 6.51a20.06 20.06 0 0 1-7.64 5.35 27.72 27.72 0 0 1-10.4 1.84Z"
          className="cls-111-1"
        />
        <path d="M474.17 101.54a2.8 2.8 0 0 1-2.81-2.85 2.65 2.65 0 0 1 .83-2 2.75 2.75 0 0 1 2-.79 2.64 2.64 0 0 1 1.92.79 2.67 2.67 0 0 1 .81 2 2.73 2.73 0 0 1-.81 2 2.62 2.62 0 0 1-1.94.85ZM492.79 101.54a12.52 12.52 0 0 1-6.09-1.45 10.84 10.84 0 0 1-4.19-4 11.83 11.83 0 0 1 0-11.64 10.87 10.87 0 0 1 4.19-4 12.63 12.63 0 0 1 6.09-1.45 11.58 11.58 0 0 1 5.49 1.26A8.56 8.56 0 0 1 502 84l-3.55 2.15a6.67 6.67 0 0 0-2.5-2.33 6.74 6.74 0 0 0-3.16-.77 7.23 7.23 0 0 0-3.63.89 6.6 6.6 0 0 0-2.5 2.5 8.35 8.35 0 0 0 0 7.66 6.46 6.46 0 0 0 2.5 2.5 7.44 7.44 0 0 0 3.63.86 7 7 0 0 0 3.16-.74 6.5 6.5 0 0 0 2.5-2.35l3.55 2.26a8.88 8.88 0 0 1-3.68 3.63 11.47 11.47 0 0 1-5.53 1.28ZM516.66 101.54a12.07 12.07 0 0 1-6-1.45 10.88 10.88 0 0 1-5.66-9.78 10.91 10.91 0 0 1 5.66-9.83 13.12 13.12 0 0 1 11.95 0 10.58 10.58 0 0 1 4.11 4 12.11 12.11 0 0 1 0 11.64 10.54 10.54 0 0 1-4.13 4 12.1 12.1 0 0 1-5.93 1.42Zm0-4.05a7.31 7.31 0 0 0 3.55-.86 6.14 6.14 0 0 0 2.45-2.52 7.81 7.81 0 0 0 .89-3.8 7.73 7.73 0 0 0-.89-3.84 6.34 6.34 0 0 0-2.45-2.5 7.11 7.11 0 0 0-3.55-.89 6.93 6.93 0 0 0-3.55.89 6.71 6.71 0 0 0-2.46 2.5 7.53 7.53 0 0 0-.93 3.84 7.61 7.61 0 0 0 .93 3.8 6.48 6.48 0 0 0 2.46 2.52 7.12 7.12 0 0 0 3.55.86ZM561.49 79a10.33 10.33 0 0 1 4.73 1 7.48 7.48 0 0 1 3.22 3.18 11.19 11.19 0 0 1 1.18 5.45v12.59H566v-12a6.61 6.61 0 0 0-1.36-4.59 5 5 0 0 0-3.92-1.48 6.42 6.42 0 0 0-3.16.76 5.19 5.19 0 0 0-2.15 2.29 8.46 8.46 0 0 0-.76 3.8v11.23H550v-12a6.56 6.56 0 0 0-1.39-4.59 5.06 5.06 0 0 0-3.9-1.48 6.56 6.56 0 0 0-3.18.76 5.09 5.09 0 0 0-2.15 2.29 8.75 8.75 0 0 0-.74 3.8v11.23H534v-22h4.41v5.83l-.78-1.74a7.54 7.54 0 0 1 3.2-3.2 10.32 10.32 0 0 1 4.89-1.13 9.43 9.43 0 0 1 5.37 1.52 7.64 7.64 0 0 1 3.06 4.67l-1.95-.74a8.4 8.4 0 0 1 3.56-3.95 11 11 0 0 1 5.73-1.5Z" />
        <image
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAABBCAYAAAD2ZAWhAAAACXBIWXMAAAsSAAALEgHS3X78AAABGklEQVQ4T72SwW6EMAxEn0PCwqH93Er97ZUKgdXiHuyAoZxryVrxMuNMkhU+PpVQiWGAlPbO9D30PawrgINQB/DfdK/ougBKgVJ2cGMpxTLsIGfIOVjCx6EQCaCdY7eUYgrvTHe1dN1l2xDbZoRVU6R0s+3JElZN0TIE8Aa6A0AFHlExo6oHgBmRGRibogKgWgESMAPhtCafUR0NwOKKpQ2d3Eocmg8Ab+9d8UR1jIrqtsGBbLamk1t4AgMqzSLVbDqA1BZ9A5mALSOyAmvcZSFUwqJvrbMfakH10SwvAEReDUxcLtlyqA7xgjIiP1ERLshChZezpOBvlbCnVEQUET2CeSXCwWzGH+CRW4mqIl/f5QRinf+C/wZ+AXLBVeIkDn5PAAAAAElFTkSuQmCC"
          width={4}
          height={65}
          transform="translate(61.07 59.27)"
        />
        <path
          d="M115.93 30.55 63.02 61.09 10.11 30.55 63.02 0l52.91 30.55z"
          style={{
            fill: "url(#linear-gradient-111)",
          }}
        />
        <path
          d="M65.05 64.79v.02l50.88-18.43V35.42L65.05 64.79z"
          style={{
            fill: "url(#linear-gradient-111-2)",
          }}
        />
        <path
          d="M115.93 46.38v47.8l-50.88 29.37 61-22.22V42.72Z"
          style={{
            fill: "url(#linear-gradient-111-3)",
          }}
        />
        <path
          d="M61 64.79 10.11 35.42v10.95L61 64.8v-.01z"
          style={{
            fill: "url(#linear-gradient-111-4)",
          }}
        />
        <path
          d="m.05 101.33 61 22.22-50.94-29.37V46.37L0 42.71Q0 72 .05 101.33Z"
          style={{
            fill: "url(#linear-gradient-111-5)",
          }}
        />
      </g>
    </g>
  </svg>
)


